import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import { useData } from '../../../../contexts';
import { Grid, TextField } from '@mui/material';
import { MdFilterAltOff, MdLibraryAddCheck } from 'react-icons/md';
import { PiNotePencilDuotone } from 'react-icons/pi';

export const AccordionThema = forwardRef((props, selIndRef) => {
  const { themas, indicatorThema, globalSourceFilter } = props;
  const { selectedIndicators, interfaceColor } = useData();

  const [themesList, setThemesList] = useState([]);
  const [indicatorsList, setIndicatorsList] = useState([]);
  const [sourceFilter, setSourceFilter] = useState([]);

  const [searchData, setSearchData] = useState([]);
  const [inputText, setInputText] = useState('');

  let inputHandler = (e) => {
    //convert input text to lower case
    var lowerCase = e.target.value.toLowerCase();
    setInputText(lowerCase);
  };

  useImperativeHandle(selIndRef, () => ({
    getSelInd: () => {
      return indicatorsList;
    },

    getSelSource: () => {
      return sourceFilter;
    },
  }));

  const checkCommonElement = (idThema: number) => {
    let hasCommon = false;
    const indList = indicatorsList.filter((d: any) => {
      return d.checked && d.enabled && d.idThema === idThema;
    });
    if (indList?.length > 0) hasCommon = true;
    return hasCommon;
  };

  const changeHandlerIndicator = (data: any, index: number) => {
    let indOut: any = indicatorsList.map((d: any, i) => {
      return data.id === d.id ? { ...d, checked: !d.checked } : d;
    });

    let unique = [...new Set(searchData.map((d: any) => d.id))];

    if (data.id === -999) {
      indOut = indicatorsList.map((d: any, i) => {
        return unique.includes(d.id) ? { ...d, checked: true } : { ...d };
      });
    }

    setIndicatorsList(indOut);

    const themeOut: any = themesList.map((d: any, i) => {
      let themeChecked = true;
      const indicators = indOut.filter((a: any) => {
        return a.idThema === data.idThema;
      });
      indicators.forEach((d: any) => {
        if (d.checked === false) themeChecked = false;
      });
      return d.id === data.idThema ? { ...d, checked: themeChecked } : d;
    });
    setThemesList(themeOut);
  };

  const changeHandlerThema = (data: any, index: number) => {
    const themeOut: any = themesList.map((d: any, i) => {
      if (data.id === d.id) {
        const indOut: any = indicatorsList.map((a: any) => {
          if (a.idThema === d.id && a.enabled) a.checked = !d.checked;
          return a;
        });
        setIndicatorsList(indOut);
      }

      return data.id === d.id ? { ...d, checked: !d.checked } : d;
    });
    setThemesList(themeOut);
  };

  const changeHandlerSource = (data: any, index: number) => {
    const sourceOut: any = sourceFilter.map((d: any, i) => {
      return data.name === d.name ? { ...d, checked: !d.checked } : d;
    });

    const indOut: any = indicatorsList.map((a: any) => {
      const surveyChecked = sourceOut.find(
        (d: any) => d.name === 'Survey',
      ).checked;
      const registerChecked = sourceOut.find(
        (d: any) => d.name === 'Register',
      ).checked;

      if (a.isSurvey && surveyChecked) a.enabled = true;
      if (a.isSurvey && !surveyChecked) {
        a.enabled = false;
        a.checked = false;
      }

      if (!a.isSurvey && registerChecked) a.enabled = true;
      if (!a.isSurvey && !registerChecked) {
        a.enabled = false;
        a.checked = false;
      }
      return a;
    });

    const themeOut: any = themesList.map((d: any) => {
      let themeChecked = true;
      const indicators = indOut.filter((a: any) => {
        return a.idThema === d.id;
      });

      indicators.forEach((b: any) => {
        if (b.checked === false && b.enabled) themeChecked = false;
      });

      d.show =
        indicators.filter((d: any) => d.enabled).length > 0 ? true : false;

      d.checked = themeChecked;
      return d;
    });

    setThemesList(themeOut);
    setIndicatorsList(indOut);
    setSourceFilter(sourceOut);
  };

  const clickHandlerReset = () => {
    const themesOut = themesList.map((d, i) => {
      d.checked = false;
      return d;
    });

    const indicatorsOut = indicatorsList.map((d, i) => {
      d.checked = false;
      return d;
    });

    setThemesList(themesOut);
    setIndicatorsList(indicatorsOut);
  };

  const clickHandlerAll = () => {
    const themesOut = themesList.map((d: any, i) => {
      if (d.show) d.checked = true;
      return d;
    });

    const indicatorsOut = indicatorsList.map((d: any, i) => {
      if (d.enabled) d.checked = true;
      return d;
    });

    setThemesList(themesOut);
    setIndicatorsList(indicatorsOut);
  };

  useEffect(() => {
    if (indicatorThema && indicatorThema.length > 0) {
      const sourceOut = structuredClone(globalSourceFilter);

      const indOut = structuredClone(indicatorThema).map(
        (d: any, i: number) => {
          d.checked = selectedIndicators.includes(d.idIndicator);

          const surveyChecked = sourceOut.find(
            (d: any) => d.name === 'Survey',
          ).checked;
          const registerChecked = sourceOut.find(
            (d: any) => d.name === 'Register',
          ).checked;

          if (d.isSurvey && surveyChecked) d.enabled = true;
          if (d.isSurvey && !surveyChecked) {
            d.enabled = false;
            d.checked = false;
          }

          if (!d.isSurvey && registerChecked) d.enabled = true;
          if (!d.isSurvey && !registerChecked) {
            d.enabled = false;
            d.checked = false;
          }
          return d;
        },
      );

      if (themas && themas.length > 0) {
        const themeOut = structuredClone(themas).map((d: any) => {
          let themeChecked = true;
          const indicators = indOut.filter((a: any) => {
            return a.idThema === d.id;
          });

          indicators.forEach((b: any) => {
            if (b.checked === false && b.enabled) themeChecked = false;
          });

          d.show =
            indicators.filter((d: any) => d.enabled).length > 0 ? true : false;

          d.checked = themeChecked;
          return d;
        });
        setThemesList(themeOut);
      }

      setSourceFilter(sourceOut);
      setIndicatorsList(indOut);
    }
  }, [themas, indicatorThema, selectedIndicators]);

  useEffect(() => {
    let filteredData: any = [];
    if (inputText !== '') {
      filteredData = indicatorsList.filter((el) => {
        return el.indicator.toLowerCase().includes(inputText);
      });
    }

    const ids = filteredData.map(({ idIndicator }) => idIndicator);
    const out = filteredData.filter(
      ({ idIndicator }, index) => !ids.includes(idIndicator, index + 1),
    );

    setSearchData(out);
  }, [inputText, indicatorsList]);

  return (
    <>
      <Grid container style={{ width: '100%', paddingTop: '20px' }}>
        <Grid item xs={12} sx={{ fontSize: '13px' }}>
          Kies één of meerdere thema's en indicatoren
        </Grid>

        <Grid
          item
          xs={5}
          style={{ cursor: 'pointer', marginTop: '2px', paddingTop: '8px' }}
        >
          <div onClick={() => clickHandlerAll()}>
            <span
              style={{
                fontSize: '13px',
                color: interfaceColor,
                float: 'left',
                paddingLeft: '8px',
                textDecoration: 'underline',
              }}
            >
              Selecteer alles
            </span>
            <MdLibraryAddCheck
              style={{
                color: interfaceColor,
                float: 'left',
                marginRight: '18px',
                marginTop: '2px',
                paddingLeft: '4px',
              }}
            />
          </div>
        </Grid>
        <Grid
          item
          xs={5}
          style={{
            cursor: 'pointer',
            marginTop: '2px',
            paddingTop: '8px',
          }}
        >
          <div onClick={() => clickHandlerReset()}>
            <span
              style={{
                fontSize: '13px',
                color: interfaceColor,
                float: 'left',
                textDecoration: 'underline',
              }}
            >
              Wis selectie
            </span>
            <MdFilterAltOff
              style={{
                color: interfaceColor,
                float: 'left',
                marginRight: '18px',
                marginTop: '2px',
                paddingLeft: '4px',
              }}
            />
          </div>
        </Grid>
        <Grid xs={2}></Grid>
        <Grid
          item
          xs={12}
          style={{
            marginTop: '8px',
          }}
        >
          <div style={{ paddingBottom: '8px', paddingLeft: '12px' }}>
            {sourceFilter.map((d: any, i: number) => {
              return (
                <FormControlLabel
                  label={`Toon ${
                    d.name === 'Survey'
                      ? d.name.toLowerCase() + '-'
                      : d.name.toLowerCase()
                  }indicatoren`}
                  sx={{
                    '& :hover': {
                      color: interfaceColor,
                      fontSize: '13px',
                    },
                    paddingRight: '36px',
                  }}
                  control={
                    <Checkbox
                      sx={{ pointerEvents: 'none' }}
                      indeterminate={false}
                      checked={d.checked}
                      onChange={() => changeHandlerSource(d, i)}
                    />
                  }
                />
              );
            })}
            <div className="search" style={{ paddingTop: 16 }}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                onChange={inputHandler}
                fullWidth
                label="Zoek één of meerdere indicatoren"
              />
            </div>
            <div>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  fontSize: '13px',
                }}
              >
                {[
                  {
                    isSurvey: false,
                    indicator: 'Selecteer alle zoekresultaten',
                    id: -999,
                    enabled: searchData.length > 0 ? true : false,
                    checked: false,
                  },
                ]
                  .concat(searchData)
                  .map((d: any, i: number) => {
                    return (
                      <FormControlLabel
                        label={
                          d.isSurvey ? (
                            <p>
                              {d.indicator}{' '}
                              <PiNotePencilDuotone
                                title="Survey"
                                style={{
                                  position: 'relative',
                                  top: '2px',
                                  left: '4px',
                                }}
                              />
                            </p>
                          ) : (
                            d.indicator
                          )
                        }
                        sx={{
                          paddingLeft: '12px',
                          '& :hover': {
                            color: interfaceColor,
                          },
                          fontSize: '13px',
                        }}
                        control={
                          <Checkbox
                            checked={d.checked && d.enabled}
                            disabled={!d.enabled}
                            onChange={() => changeHandlerIndicator(d, i)}
                          />
                        }
                      />
                    );
                  })}
              </Box>
            </div>
          </div>
          {themesList
            .filter((a: any) => {
              return a.show === true;
            })
            .map((d: any, i: number) => {
              return (
                <Accordion
                  // sx={{
                  //   '& .MuiAccordionSummary-content': {
                  //     margin: '0',
                  //   },
                  //   '& .MuiAccordionSummary-root:hover, .MuiButtonBase-root:hover':
                  //     {
                  //       cursor: 'default',
                  //     },
                  // }}
                  sx={{
                    '& .MuiAccordionSummary-content': {
                      justifyContent: 'start',
                      width: '100%',
                    },
                  }}
                >
                  <AccordionSummary
                    sx={{ minHeight: '40px', width: '100%' }}
                    // expandIcon={<ExpandMoreIcon sx={{ cursor: 'pointer' }} />}
                  >
                    {/* <FormControlLabel
                      label={d.thema}
                      sx={{
                        textDecoration: 'underline',
                        '& :hover': {
                          color: interfaceColor,
                        },
                      }}
                      control={
                        <Checkbox
                          sx={{ pointerEvents: 'none' }}
                          indeterminate={!d.checked && checkCommonElement(d.id)}
                          checked={d.checked}
                          onChange={() => changeHandlerThema(d, i)}
                        />
                      }
                    /> */}
                    <Grid container sx={{ width: '100%' }}>
                      <Grid item xs={10}>
                        <ExpandMoreIcon
                          sx={{
                            position: 'relative',
                            top: '5px',
                            cursor: 'pointer',
                          }}
                        />
                        <FormControlLabel
                          label={d.thema}
                          sx={{
                            position: 'relative',
                            top: '2px',
                            left: '20px',
                            '& :hover': {
                              color: interfaceColor,
                            },
                          }}
                          control={<></>}
                        />
                      </Grid>
                    </Grid>

                    <div>
                      <FormControlLabel
                        label={''}
                        sx={{ marginRight: '0px' }}
                        control={
                          <Checkbox
                            sx={{ pointerEvents: 'none' }}
                            indeterminate={
                              !d.checked && checkCommonElement(d.id)
                            }
                            checked={d.checked}
                            onChange={() => changeHandlerThema(d, i)}
                          />
                        }
                      />
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      {indicatorsList
                        .filter((a: any) => {
                          return a.enabled === true;
                        })
                        .filter((a: any) => a.idThema === d.id)
                        .map((d: any, i: number) => {
                          return (
                            <FormControlLabel
                              label={
                                d.isSurvey ? (
                                  <p>
                                    {d.indicator}{' '}
                                    <PiNotePencilDuotone
                                      title="Survey"
                                      style={{
                                        position: 'relative',
                                        top: '2px',
                                        left: '4px',
                                      }}
                                    />
                                  </p>
                                ) : (
                                  d.indicator
                                )
                              }
                              sx={{
                                display: 'table',
                                paddingLeft: '12px',
                                '& :hover': {
                                  color: interfaceColor,
                                },
                              }}
                              control={
                                <div
                                  style={{
                                    display: 'table-cell',
                                    width: '33px',
                                  }}
                                >
                                  <Checkbox
                                    checked={d.checked && d.enabled}
                                    disabled={!d.enabled}
                                    onChange={() =>
                                      changeHandlerIndicator(d, i)
                                    }
                                  />
                                </div>
                              }
                            />
                          );
                        })}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              );
            })}{' '}
        </Grid>
      </Grid>
    </>
  );
});

export default React.memo(AccordionThema);
